<template>
  <div class="partner_info">
    <el-tabs v-model="activeName">
      <el-tab-pane label="商单详情" name="1">
        <cpxQuotientDeal :cxorid='cxorid' v-if="activeName==1"/>
      </el-tab-pane>
      <el-tab-pane label="关联商品列表" name="2">
        <cpxRelatedProducts :cxorid='cxorid' v-if="activeName==2"/>
      </el-tab-pane>
      <el-tab-pane label="客户意向达人" name="3">
        <kehuyixiang :cxorid='cxorid' v-if="activeName==3"/>
      </el-tab-pane>
      <el-tab-pane label="待选达人" name="4">
        <cpxKolSelected :cxorid='cxorid' v-if="activeName==4"/>
      </el-tab-pane>
      <el-tab-pane label="已选定合作达人" name="5">
        <partner-selected :cxorid='cxorid' v-if="activeName==5"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import kehuyixiang from "@/components/cpx/kehuyixiang.vue";//客户意向达人
import cpxRelatedProducts from "@/components/cpx/cpx_related_products.vue";//关联商品列表
import partnerSelected from "@/components/cpx/partner_selected.vue";//已选定合作达人
import cpxKolSelected from "@/components/cpx/cpx_kol_selected.vue";//待选达人
import cpxQuotientDeal from "@/components/cpx/cpx_quotient_deal.vue";//商单详情
export default {
  name:'partner_info',
  components: {
    kehuyixiang,
    partnerSelected,
    cpxKolSelected,
    cpxQuotientDeal,
    cpxRelatedProducts
  },
  data(){
    return{
      cxorid:'',
      activeName: '2'
    }
  },
  created(){
    this.cxorid = this.$route.query.cxorid;
  }
}
</script>
<style scoped>
.partner_info >>> .el-tabs__content{
  overflow: visible;
}
.partner_info >>> .el-tabs__item{
  font-size: 20px;
}
.partner_info >>> .el-tabs__nav{
  height: 60px;
}
.partner_info >>> .el-tabs__item:focus.is-active.is-focus:not(:active){
  border:0;
  box-shadow: 0 0 0 0 #fff;
}
</style>